import { createAction } from 'redux-actions'


export const getFootTitle = createAction('getFootTitle')
export const saveFootTitle = createAction('saveFootTitle')